import { useAtomValue } from 'jotai';
import { userAtom } from '@/global-store';
import { getGovernanceDomainAccessLevel } from '@/guards/governanceAccess';
import { useEffectiveUserRights } from '@/http/queries/useEffectiveUserRights';

/** See getGovernanceDomainAccessLevel for the access model. */
export function useGovernanceAccess(domainId?: number) {
  const effectiveRights = useEffectiveUserRights();
  const user = useAtomValue(userAtom);
  const isPrivileged = user?.isAdmin || user?.isSalesAdmin;
  const isLoading = !isPrivileged && effectiveRights === null;
  const accessLevel = getGovernanceDomainAccessLevel({
    domainId,
    effectiveRights,
    user,
  });

  return {
    accessLevel,
    canEdit: accessLevel === 'editor',
    hasAccess: accessLevel !== null,
    isPrivileged,
    isLoading,
  };
}

/**
 * Predicate form for lists: decides access per Governance domain without
 * re-running the hooks for every row.
 */
export function useCanEditGovernanceDomain(): (domainId: number) => boolean {
  const effectiveRights = useEffectiveUserRights();
  const user = useAtomValue(userAtom);

  return (domainId: number) =>
    getGovernanceDomainAccessLevel({
      domainId,
      effectiveRights,
      user,
    }) === 'editor';
}
